import { useDispatch } from "react-redux";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { useNavigation } from "../../../hooks/useNavigation";

interface BrowserWindow extends Window {
  MSStream: any;
  opera: any;
}

declare const window: BrowserWindow;

export const useAppCoupon = () => {
  const dispatch = useDispatch();
  const { navigateToPage } = useNavigation();

  const getDevicePlatform = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    } else if (/Android/.test(userAgent)) {
      return "Android";
    } else {
      return "Unknown";
    }
  };

  const navigateToAppStore = () => {
    const appStoreUrl = process.env.REACT_APP_APP_STORE_URL;
    const playStoreUrl = process.env.REACT_APP_PLAY_STORE_URL;

    if (!appStoreUrl || !playStoreUrl) return;

    const platform = getDevicePlatform();
    if (platform === "iOS") {
      window.location.href = appStoreUrl;
    } else if (platform === "Android") {
      window.location.href = playStoreUrl;
    } else {
      console.log("Unsupported platform.");
    }
  };

  const handleUseAppCoupon = () => {
    const appURLScheme = process.env.REACT_APP_DEEP_LINK_BASE_URL
      ? process.env.REACT_APP_DEEP_LINK_BASE_URL.replace("selforder", "")
      : "";
    if (appURLScheme !== "") {
      dispatch(appActions.showLoading());

      const url = `${process.env.REACT_APP_DEEP_LINK_BASE_URL}/?weborder=true`;

      window.open(url, "_self");
      setTimeout(function () {
        setTimeout(() => {
          navigateToPage(PageRoutes.APP_LINKAGE, false, {
            waitAtOnce: getDevicePlatform() === "iOS",
          });
          window.location.reload();
        }, 10);
      }, 10);
    }
  };

  return { handleUseAppCoupon, navigateToAppStore };
};
